<template>
    <kgr-profile-part :heading="memberShortProfile.fullNameWithTitle()">
        <template #content>
            <div class="kgr-postfix kgr-postfix--bigGutters">
                <div class="kgr-postfix__fixed">
                    <kgr-profile-image
                        :src="myAvatarUrl"
                        :alt="memberShortProfile.fullNameWithTitle()"
                        size="M"
                    />
                </div>
                <div class="kgr-postfix__fluid">
                    <dl class="kgr-definitionList kgr-definitionList--horizontal kgr-definitionList--200">
                        <dt
                            v-t="'Geschlecht'"
                            class="kgr-definitionList__term"
                        ></dt>
                        <dd
                            v-t="memberShortProfile.gender || 'gender.u'"
                            class="kgr-definitionList__definition"
                        ></dd>
                        <template v-if="memberShortProfile.dateOfBirth">
                            <dt
                                v-t="'Geburtstag'"
                                class="kgr-definitionList__term"
                            ></dt>
                            <dd class="kgr-definitionList__definition">
                                {{ memberShortProfile.dateOfBirth }} ({{ formattedBirthday }})
                            </dd>
                        </template>
                        <template v-if="memberShortProfile.departments && 0 !== memberShortProfile.departments.length">
                            <dt
                                v-t="'Abteilungen'"
                                class="kgr-definitionList__term"
                            ></dt>
                            <dd
                                v-for="department in memberShortProfile.departments"
                                :key="department"
                                class="kgr-definitionList__definition"
                            >
                                {{ department }}
                            </dd>
                        </template>
                        <template v-if="memberShortProfile.teams && 0 !== memberShortProfile.teams.length">
                            <dt
                                v-t="'Teams'"
                                class="kgr-definitionList__term"
                            ></dt>
                            <dd
                                v-for="team in memberShortProfile.teams"
                                :key="team"
                                class="kgr-definitionList__definition"
                            >
                                {{ team }}
                            </dd>
                        </template>
                        <template v-if="memberShortProfile.dogRelations && memberShortProfile.dogRelations.length > 0">
                            <dt class="kgr-definitionList__term">
                                {{ $t('Hunde') }}
                            </dt>
                            <dd
                                v-for="relation in memberShortProfile.dogRelations"
                                :key="relation.id"
                                class="kgr-definitionList__definition"
                            >
                                <a
                                    :href="`/backend/clubs/dogs/${relation.dog.id}/show`"
                                    class="kgr-link"
                                >
                                    {{ relation.dog.name }}
                                </a>
                                ({{ $t(`club.dog.memberRelation.association.${relation.association}`) }})
                            </dd>
                        </template>
                        <template v-if="memberShortProfile.memberFilterFlags && 0 !== memberShortProfile.memberFilterFlags.length">
                            <dt class="kgr-definitionList__term">
                                {{ $t('Sortier- und Auswahlkriterien') }}
                            </dt>
                            <dd
                                v-for="filterFlag in memberShortProfile.memberFilterFlags"
                                :key="filterFlag.value"
                                class="kgr-definitionList__definition"
                            >
                                {{ filterFlag.value }}
                            </dd>
                        </template>
                        <template v-if="memberShortProfile.memberClassifications && 0 !== memberShortProfile.memberClassifications.length">
                            <dt class="kgr-definitionList__term">
                                {{ $t('Zuordnungen') }}
                            </dt>
                            <dd
                                v-for="classification in memberShortProfile.memberClassifications"
                                :key="classification.value"
                                class="kgr-definitionList__definition"
                            >
                                {{ classification.value }}: {{ classification.notice }}
                            </dd>
                        </template>
                        <template v-if="null !== remainingSalesListCredits">
                            <dt
                                v-t="'Verfügbares Guthaben (Verkaufsliste)'"
                                class="kgr-definitionList__term"
                            ></dt>
                            <dd class="kgr-definitionList__definition">
                                {{ remainingSalesListCredits }}
                            </dd>
                        </template>
                    </dl>
                </div>
            </div>
        </template>
    </kgr-profile-part>
</template>

<script>
import MemberShortProfile, { MemberShortProfileMember } from '../../../js/dto/MemberShortProfile.js';
import Money from '../../../js/dto/Money.js';
import ProfileImage from '../../common/ProfileImage.vue';
import ProfilePart from '../../short-profile/ProfilePart.vue';
import UrlMixin from '../UrlMixin.vue';
import moment from 'moment';

export default {
    name: 'KgrMemberPartBasic',
    components: {
        'kgr-profile-part': ProfilePart,
        'kgr-profile-image': ProfileImage,
    },
    mixins: [UrlMixin],
    props: {
        memberShortProfile: {
            type: [MemberShortProfile, MemberShortProfileMember],
            required: true,
        },
    },
    computed: {
        remainingSalesListCredits() {
            if (this.memberShortProfile.salesListCredits) {
                const salesListCredits = Money.fromData(this.memberShortProfile.salesListCredits);
                return `${salesListCredits.toLocalizedString()} ${salesListCredits.currency}`;
            }
            return null;
        },
        myAvatarUrl() {
            return this.avatarUrl(this.memberShortProfile.id, this.memberShortProfile.hasAvatar, this.memberShortProfile.gender, this.memberShortProfile.avatarFileName);
        },
        formattedBirthday() {
            const years = moment().diff(moment(this.memberShortProfile.dateOfBirth, 'DD.MM.YYYY'), 'years');

            return this.$t('{years} Jahre', { years });
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">

</style>
